import React from 'react';

export default function About() {
  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Manifesto  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">ABOUT</h1>
      <p className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3">
        Independent · London · Internet Radio
      </p>

      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      <div className="max-w-2xl text-left space-y-6 font-mono-r text-sm md:text-base leading-relaxed">
        <p>
          OSO London is an independent internet radio station broadcasting
          24 hours a day from a small studio in East London. We exist for
          the music, the conversations and the city that holds them
          together.
        </p>
        <p>
          The signal is built by a rotating cast of residents, friends and
          guests — DJs, producers, writers and listeners. There is no
          algorithm, no targeting and no shareholders to please. Just a
          stream, a schedule and a city worth tuning into.
        </p>
        <p>
          We broadcast in black and white because the music speaks loud
          enough.
        </p>
      </div>

      <div className="ascii-divider my-12">·  ·  ·  ·  ·</div>

      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { k: 'Founded', v: '2023' },
          { k: 'Studio',  v: 'London E1' },
          { k: 'Format',  v: 'Free-form' },
        ].map(({ k, v }) => (
          <div key={k} className="hairline p-6 text-left">
            <div className="text-[10px] font-mono-r tracking-[0.4em] uppercase opacity-60">{k}</div>
            <div className="font-display text-4xl mt-2">{v}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
